module.exports = __webpack_public_path__ + "img/shuiyinpaizhao.866653ad.png";